import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { TickIcon } from '../../../assets/icons';
import CSS from './Checkbox.scss';
const Checkbox = ({ onChange, checked, label, disabled = false }) => {
    const classes = [CSS.Checkbox];
    if (checked)
        classes.push(CSS.Active);
    if (disabled)
        classes.push(CSS.Disabled);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.join(' '), onClick: disabled ? undefined : () => onChange(!checked), "data-testid": "Checkbox", children: checked && _jsx(TickIcon, { hexFill: '#FFFFFF' }) }), label && (_jsx("span", { className: `${CSS.ChkbxLabel} ${disabled ? CSS.Disabled : ''}`, onClick: disabled ? undefined : () => onChange(!checked), "data-testid": "CheckboxLabel", children: label }))] }));
};
export default memo(Checkbox);
